// extracted by mini-css-extract-plugin
export default {"bg":"PostListItem_bg__w6Y8B","fullV":"PostListItem_fullV__UnrpP"};